var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{class:_vm.cssClass,attrs:{"label":_vm.$t(_vm.reason),"position":"is-left"}},[_c('Button',{staticClass:"system-rejected-button",attrs:{"type":"is-light","icon-pack":"fas","icon-right":"flag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }